import { ChatActions, ChatGetState, ChatSetState } from "../chatTypes";

type QueryActions = Pick<ChatActions, "setExecuting" | "setAbortController" | "stopGeneration">;

export const createQueryActions = (set: ChatSetState, get: ChatGetState): QueryActions => ({
  setExecuting: (executing: boolean): void => {
    set({ isExecuting: executing });
  },

  setAbortController: (controller: AbortController | null): void => {
    set({ currentAbortController: controller });
  },

  stopGeneration: (): void => {
    const { currentAbortController, setExecuting, handleComplete, setLoading, setAbortController, setCreatingChunks } = get();

    if (currentAbortController) {
      currentAbortController.abort();
      setAbortController(null);
    }

    handleComplete();

    setExecuting(false);
    setLoading(false);
    setCreatingChunks(false);
  }
});
